import "./ProjectsHero.css";
function Projects() {
	const projects = [
		{
			title: "Salvi BPO Financeiro",
			description: "Um site institucional para uma empresa de BPO Financeiro.",
			image: "/assets/salvi.png",
			url: "https://salvibpofinanceiro.com",
		},
		{
			title: "Orçamento Grátis",
			description:
				"Sistema gratuito para criação de orçamentos online. Crie orçamentos profissionais de forma rápida e eficiente.",
			image: "/assets/orcamentogratis.png",
			url: "https://orcamentogratis.com.br/",
			repo: "https://github.com/srclayton/orcamento-gratis",
		},
		{
			title: "Portfólio - Retrô OS!",
			description:
				"Meu portfólio pessoal, com um tema retrô de sistema operacional.",
			image: "/assets/srocha.png",
			url: "https://srocha.dev",
			repo: "https://github.com/srclayton/retro-portfolio-website",
		},
	];
	return (
		<section id="projects">
			<div className="h-100 pt-5">
				<div className="w-100 pt-5 px-5 mt-5 color-100">
					<h2 className="fs-2">Projetos Recentes</h2>
					<p className="color-600 fs-5">
						Aqui estão alguns dos meus projetos mais recentes.
					</p>
				</div>
				<div
					className="row py-5 px-sm-5 justify-content-center align-items-stretch "
					id="projectsList"
				>
					{projects.map((project) => {
						return (
							<div
								className="col-12 col-sm-6 col-lg-4 py-3 project"
								key={project.title}
							>
								<div className="box d-flex flex-column bg-700 scale h-100 ">
									<div className="box-image ">
										<a
											href={project.url}
											target="_blank"
											rel="noreferrer"
											className=""
										>
											<img
												src={project.image}
												className="img-fluid p-3 ratio ratio-16x9"
												alt="imagem do projeto"
											/>
										</a>
									</div>
									<div className="box-content p-3 flex-grow-1	">
										<h3 className="fs-4 color-accents-yellow">
											<a
												href={project.url}
												target="_blank"
												className="text-decoration-none"
												rel="noreferrer"
											>
												{project.title}
											</a>
										</h3>
										<p className="fs-5">{project.description}</p>
									</div>
									<div className="box-footer text-end">
										<a
											className="btn color-accents-blue"
											target="_blank"
											href={project.repo ? project.repo : project.url}
											rel="noreferrer noopener"
										>
											Ver Projeto
										</a>
									</div>
								</div>
							</div>
						);
					})}
				</div>
				<div className="w-100">
					Veja mais projetos{" "}
					<a href="/projetos" className="color-accents-blue" rel="noreferrer">
						aqui
					</a>
					<svg width="16" height="16" data-icon="external-arrow">
						<symbol id="ai:local:external-arrow" viewBox="0 0 25 26">
							<path
								fill="none"
								stroke="currentColor"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M17.708 7.792 7.292 18.208M17.708 7.792H8.333m9.375 0v9.375"
							></path>
						</symbol>
						<use href="#ai:local:external-arrow"></use>
					</svg>
					<p>
						você pode ver todos os meus projetos no meu{" "}
						<a
							href="https://github.com/srclayton"
							target="_blank"
							className="color-accents-blue"
							rel="noreferrer"
						>
							GitHub
						</a>
						.
					</p>
				</div>
			</div>
		</section>
	);
}

export default Projects;
